
<div style="min-height: calc(100% - 32px)" *ngIf="!showEdit">
  <div *ngIf="!addmode && !editmode && !flagAddDef && !flagEditDef">
    <h1
      style="
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
          Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        font-weight: 500;
        color: #105481;
        margin-bottom: 0.5rem;
        font-size: 2.5rem;
        font-weight: 500;
        line-height: 1.2;
      "
      id="delegationHeader"
    >
      Delegering
    </h1>
  </div>

<div style="margin-top: 40px" >
  <p-table
    #dt
    [value]="delegation"
    id="tb_id"
    [rows]="rowsPerPage"
    [paginator]="false"
    [rowHover]="true"
    dataKey="uuid"
    [selection]="delegation1"
    selectionMode="single"
    (onRowSelect)="onRowSelect($event)"
    [sortField]="sortField"
    [sortOrder]="sortOrder"
    [stateKey]="tableName"
    stateStorage="session"
    sortMode="single"
    [customSort]="true"
    (sortFunction)="customSort($event)"
  >
    <ng-template pTemplate="header" let-prod>
      <tr>
        <th hidden="true" id="delegId">id</th>
        <th
          style="width: 25%"
          pSortableColumn="organisationDisplayName"
          id="OrganisationHeader"
        >
          Organisation<p-sortIcon field="organisationDisplayName"></p-sortIcon>
        </th>
        <th style="width: 25%" pSortableColumn="routingInfRef.infRefName" id="infRefHeader">
          InfRef<p-sortIcon field="routingInfRef.infRefName"></p-sortIcon>
        </th>
        <th style="width: 25%" pSortableColumn="routingInfRef.serviceType" id="tyepheader">
          Type<p-sortIcon field="routingInfRef.serviceType"></p-sortIcon>
        </th>
        <th style="width: 25%" pSortableColumn="delegeredeUser" id="delegHeader">
          Delegerede<p-sortIcon field="delegeredeUser"></p-sortIcon>
        </th>
      </tr>
      <tr>
        <th id="orghead">
          <input
            style="width: 100%"
            pInputText
            type="text"
            #textInput1
            (input)="inputChange(textInput1.value, 'organisationDisplayName')"
            [value]="$any(dt.filters['organisationDisplayName'])?.value"
            class="p-column-filter"
            id="orgFilter"
          />
        </th>
        <th id="infRefhead">
          <input
            style="width: 100%"
            pInputText
            type="text"
            #textInput2
            (input)="inputChange(textInput2.value, 'routingInfRef.infRefName')"
            [value]="$any(dt.filters['routingInfRef.infRefName'])?.value"
            class="p-column-filter"
            id="infRefFilter"
          />
        </th>
        <th id="typehead">
          <input
            style="width: 100%"
            pInputText
            type="text"
            #textInput3
            (input)="inputChange(textInput3.value, 'routingInfRef.serviceType')"
            [value]="$any(dt.filters['routingInfRef.serviceType'])?.value"
            class="p-column-filter"
            id="typeFilter"
          />
        </th>
        <th id="deleghead">
          <input
            style="width: 100%"
            pInputText
            type="text"
            #textInput4
            (input)="inputChange(textInput4.value, 'delegeredeUser')"
            [value]="$any(dt.filters['delegeredeUser'])?.value"
            class="p-column-filter"
            id="delegFilter"
          />
        </th>

      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-prod>
      <tr [pSelectableRow]="prod">
        <td hidden="true" id="{{ 'delegid_' + prod?.uuid }}">{{ prod?.id }}</td>
        <td id="{{ 'orgname_' + prod?.uuid }}">{{ prod?.organisationDisplayName }}</td>
        <td id="{{ 'infref_' + prod?.uuid }}">{{ prod.routingInfRef.infRefName }}</td>
        <td id="{{ 'servicetype_' + prod?.uuid }}">
          {{ getServiceTypeText(prod?.routingInfRef?.serviceType) }}
        </td>
        <td>
          <span [pTooltip]="prod?.delegeredeUser" id="{{ 'delegeredeusers_' + prod?.uuid }}">
            {{ prod?.delegeredeUser }}
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table> 
  <br />
  <ngb-pagination #paginationDelegation *ngIf="showPagination && !showEdit" aria-label="pagination"
    class="d-flex justify-content-center" [collectionSize]="totalRecords" [(page)]="currentPage" [pageSize]="rowsPerPage"
    [maxSize]="5" [rotate]="true" size="lg" [boundaryLinks]="false" (pageChange)="onPageChange($event)">
  </ngb-pagination>

</div>
</div>

<app-edit-delegation #editDelComponent [canEdit]="canEdit"
 *ngIf="showEdit" [delegation]="delegation1" (cancelEvent)="cancelEdit()"></app-edit-delegation>

